import { render, staticRenderFns } from "./NamesPage.vue?vue&type=template&id=8d2dcd7c&scoped=true&"
import script from "./NamesPage.vue?vue&type=script&lang=js&"
export * from "./NamesPage.vue?vue&type=script&lang=js&"
import style0 from "./NamesPage.vue?vue&type=style&index=0&id=8d2dcd7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2dcd7c",
  null
  
)

export default component.exports